<form [formGroup]="contratoForm" novalidate>
    <div class="container  border border-success rounded mt-2">
        <div id="divBottom"></div>
        <div class="alert alert-primary fade show alert-dismissible" role="alert">
            <strong><i class="fa fa-info-circle" aria-hidden="true"></i></strong>
            ¡IMPORTANTE! ANTES DE CONTINUAR, LEE ATENTAMENTE LAS SIGUIENTES INSTRUCCIONES:<br>
            <ol>
                <!--<li>Al seleccionar “Solicita tu clave”, estarás solicitando una clave de seguridad y un certificado
                    digital para la firma electrónica del contrato con Santo Tomás.<br />
                    Luego de seleccionar esta opción, recibirás vía mail los siguientes correos electrónicos desde la
                    cuenta cloudsigner@esign-la.com:
                    <ol type="a">
                        <li>El primer correo que recibas incluirá la clave que deberás utilizar al momento de firmar
                            el contrato.</li>
                        <li>Recibirás un segundo correo, que será la confirmación de que la solicitud de tu
                            certificado digital ha sido exitosa. En este mismo correo encontrarás un enlace que te
                            permitirá descargar el certificado. No es necesario que descargues este certificado para
                            continuar con el proceso de matrícula, puedes descargarlo más adelante.</li>
                        <li>El tercer y último correo tendrá el asunto “Certificado Generado Satisfactoriamente”, lo
                            que significa que ya puedes realizar la firma electrónica de tu contrato.</li>
                    </ol>
                </li>-->
                <!--<li>Una vez desplegado el apartado de firma y marcado valida estado de firma
                    <ol type="a">
                        <li>Selecciona “Solicitar contrato” y espera que se despliegue tu contrato.</li>
                        <li>Una vez revisado el contrato tienes dos opciones que es firmar y rechazar.</li>
                        <li>Si rechazas el proceso de firma se redireccionará al menú inicial para que puedas generar un nuevo proceso 
                            (admisión directa) o si tienes dudas al respecto puedes comunicarte mediante nuestras 
                            plataformas digitales o acercarte directamente a tu sede de preferencia.</li>
                        <li>Si aceptas se te redireccionara a nuestro proveedor de firma el cual debes identificarte con tu clave única.</li>
                        <li>Una vez completado tu proceso de firma se te redireccionara al paso final de resumen de contrato</li>
                    </ol>
                </li>-->

                <li>Una vez desplegado el apartado de firma, valida su estado. 
                    <ol type="a">
                        <li>Selecciona “Solicitar Contrato” y espera que se despliegue.</li>
                        <li>Una vez revisado tu contrato, tienes dos opciones: firmar o rechazar.</li>
                        <li>Si rechazas, el proceso de firma se redireccionará al menú inicial para que puedas realizar 
                        un nuevo proceso de Admisión Centralizada. En el caso de tener dudas, 
                        podrás comunicarte mediante nuestras plataformas digitales o acercarte 
                        directamente a tu sede de preferencia.</li>
                        <!--<li>Si aceptas el contrato, te redireccionará a nuestro proveedor de firma, donde deberás identificarte con tu clave única.</li>-->
                        <li>Si aceptas el contrato, la plataforma te redireccionará a nuestro proveedor de firma donde deberás identificarte con tu clave única.</li>
                        <li>Una vez completado tu proceso de firma, se te redireccionará al paso final de resumen de contrato.</li>
                    </ol>
                </li>
            </ol>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="row mt-3">

            <div class="col-md-6">
                <!-- el cliente solicitó que el botón no se oculte de momento. que desde el principio aparezcan los dos-->
                <!-- <app-apibutton text="Solicitar Clave" (click)="esignInit()" [progress]='progress'></app-apibutton> -->
                <!-- <br> -->
                <app-apibutton text="Solicitar Contrato" (click)="SolicitarContrato()" [progress]="progress">
                </app-apibutton>
                <div class="alert " role="alert" *ngIf="inforamar"
                    [ngClass]="{'alert-success':EstadoAlerta=='0','alert-warning':EstadoAlerta=='1','alert-danger':EstadoAlerta=='2'}">
                    <h4 class="alert-heading">{{titulo}}</h4>
                    <hr>
                    <p class="mb-0">{{body}}</p>
                    <app-progress *ngIf="progress"></app-progress>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="TrazabilidadFirmaECert" formControlName="TrazabilidadFirmaECert" disabled>
                    <label class="form-check-label" style="font-weight: bold;">
                        Validar Estado Firma
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="PreinscribirECert" formControlName="PreinscribirECert" disabled>
                    <label class="form-check-label" for="PreinscribirECert" style="font-weight: bold;">
                        Preinscribir Alumno
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="FirmaDocumentoTRX" formControlName="FirmaDocumentoTRX" disabled>
                    <label class="form-check-label" for="FirmaDocumentoTRX" style="font-weight: bold;">
                        Obtener Identificador Contrato
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="ContratoUST" formControlName="ContratoUST" disabled>
                    <label class="form-check-label" for="ContratoUST" style="font-weight: bold;">
                        Generación Contrato
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="SubirDocumentoECert" formControlName="SubirDocumentoECert" disabled>
                    <label class="form-check-label" for="SubirDocumentoECert" style="font-weight: bold;">
                        Enviando Contrato Proveedor Firma
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="VisualizarContrato" formControlName="VisualizarContrato" disabled>
                    <label class="form-check-label" for="VisualizarContrato" style="font-weight: bold;">
                        Visualizando Contrato
                    </label>
                </div>
                <!-- <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="Firmantes" formControlName="Firmantes" disabled>
                    <label class="form-check-label" style="font-weight: bold;">
                        Estado del Proceso
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="Firmantes" formControlName="Firmantes" disabled>
                    <label class="form-check-label" for="Firmantes">
                        Firmantes
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="UsuarioEnrolado"
                        formControlName="UsuarioEnrolado" disabled>
                    <label class="form-check-label" for="UsuarioEnrolado">
                        Firmantes Enrolados
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="GeneracionContrato"
                        formControlName="GeneracionContrato" disabled>
                    <label class="form-check-label" for="GeneracionContrato">
                        Generacion Contrato
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="BusquedaContrato"
                        formControlName="BusquedaContrato" disabled>
                    <label class="form-check-label" for="BusquedaContrato">
                        Busqueda del Contrato
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="EstadoContrato" formControlName="EstadoContrato"
                        disabled>
                    <label class="form-check-label" for="EstadoContrato">
                        Estado del Contrato
                    </label>
                </div> -->
               <!-- <app-apibutton text="Guardar y continuar" [progress]="progress" (click)="avanceFase()"
                    *ngIf="iframe && faseActual === '5'">
                </app-apibutton>-->
            </div>
        </div>

        <div class="card border border-success mt-3" *ngIf="openContrato">
            <div class="alert alert-info mt-2" role="alert">
                <!-- Te recomendamos leer con atención este contrato antes de firmar y verifiques que todos tus antecedentes
                están correctos -->
                <!--Estás a un paso de matricularte en Santo Tomás. Por tu seguridad, lee atentamente este contrato antes de
                 firmarlo. Recuerda verificar que todos tus datos estén correctos.-->
                ¡Estás a un paso de matricularte en Santo Tomás! Por tu seguridad te recomendamos leer atentamente este contrato antes de firmarlo,
                verificando que todos tus datos estén correctos.
            </div>
            <!--<div class="alert alert-info mt-2" role="alert">
                Recuerda: la clave para firmarlo está en el correo enviado desde la cuenta <u>cloudsigner@esign-la.com</u>, 
                cuyo asunto es “Clave para la firma digital de contrato Santo Tomás”.
            </div>-->

            <h5 class="card-header">Contrato
                <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#CON" role="button"
                    aria-expanded="true" aria-controls="CON"></a>
            </h5>
            <div class="collapse show" id="CON">
                <div class="card-body" style="height: 1000px;">
                    <iframe width="100%" height="100%" style="border: 0;" [src]="urlSafe" 
                        title="Santo Tomás - Contrato Matrícula"></iframe>
                        <!--*ngIf="trx!==''"-->
                </div>
                <app-apibutton text="Rechazar" (click)="CadurarPreinscripcion()" class="btn btn-sm col-6" [progress]="progress">
                </app-apibutton>
                <app-apibutton text="Aprobar" (click)="RedireccionarECert()" class="btn btn-sm col-6" [progress]="progress">
                </app-apibutton>
                <!--<button type="button" class="btn btn-secondary btn-sm col-6" [progress]="progress"
                    (click)='CadurarPreinscripcion()'>Rechazar</button>
                <button type="button" class="btn btn-primary btn-sm col-6" [progress]="progress"
                    (click)='RedireccionarECert()'>Aprobar</button>-->
               
            </div>
        </div>
        
        <!--<app-apibutton text="Guardar y continuar" [progress]="progress" (click)="avanceFase()"
            *ngIf="iframe && faseActual === '5'">
        </app-apibutton>-->
    </div>
</form>

<!-- Modal eSign -->
<!-- <div class="modal fade" id="infoCorreoESign" tabindex="-1" aria-labelledby="infoCorreoESign" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="modal-body">
                <p class="text-left">
                    <ng-container *ngIf="user">
                        {{user.UserName}}:
                    </ng-container>
                </p>
                <p class="text-left">
                    En este proceso estás solicitando una clave de seguridad y un certificado digital de firma
                    electrónica con la empresa acreditada Esign TM.
                    A continuación recibirás los siguintes correos electrónicos desde la cuenta
                    cloudsigner@esign-la.com:
                </p>
                <ol>
                    <li>El primer correo que recibas incluirá una clave, la cual deberás utilizar al momento de firmar
                        el contrato.</li>
                    <li>Recibirás un segundo correo, que será la confirmación de que la solicitud de tu certificado
                        digital ha sido exitosa. En este mismo correo encontrarás un link que te permitirá descargar el
                        certificado. No es necesario que descargues este certificado para continuar con el proceso de
                        matrícula, puedes descargarlo más adelante.</li>
                    <li>El tercer y último correo tendrá el asunto “Certificado Generado Satisfactoriamente”, lo que
                        significa que ya puedes realizar la firma elctrónica de tu contrato.</li>
                </ol>
                <p class="text-left">
                    Si anteriormente en el sistema tuviste que ingresar los datos de un apoderado, también debes generar
                    un certificado para dicho apoderado, antes de firmar el contrato.
                </p>
                <p class="text-left">
                    Todos estos pasos son por tu seguridad y resguardo.
                </p>
                <p class="text-left">
                    Atentamente,<br />
                    Dirección de Admisión,<br />
                    Santo Tomás.
                </p>
            </div>
        </div>
    </div>
</div> -->
<!-- Modal eSign -->